<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column is-10">
          <h1 class="title">
            <template v-if="id == undefined">
              {{ $translate('new_shop') }}
            </template>
            <template v-else>
              {{ $translate('modify_shop') }}
            </template>
          </h1>
        </div>
        <div class="column has-text-right">
          <b-field grouped position="is-right">
            <b-field>
              <b-tooltip
                :label="$translate('delete') | capitalize"
                position="is-left"
                v-if="id != undefined"
                type="is-danger"
              >
                <button class="button is-danger" @click="deleteItem()">
                  <b-icon icon="delete-outline"></b-icon>
                </button>
              </b-tooltip>
            </b-field>
            <b-field>
              <b-tooltip :label="$translate('save') | capitalize" position="is-left">
                <button class="button is-primary" @click="send(false)">
                  <b-icon icon="content-save-outline"></b-icon>
                </button>
              </b-tooltip>
            </b-field>
            <b-field>
              <b-tooltip :label="$translate('save_exit') | capitalize" position="is-left">
                <button class="button is-primary" @click="send(true)">
                  <b-icon icon="exit-to-app"></b-icon>
                </button>
              </b-tooltip>
            </b-field>
          </b-field>
        </div>
      </div>
      <b-field
        :type="{ 'is-danger': errors.has('mercurio_id') }"
        :message="errors.first('mercurio_id')"
        horizontal
        :label="$translate('id_mercury') | capitalize"
      >
        <b-input name="mercurio_id" v-model="shop.mercurio_id" v-validate="'required'"></b-input>
      </b-field>
      <b-field
        :type="{ 'is-danger': errors.has('company') }"
        :message="errors.first('company')"
        horizontal
        :label="$translate('customer') | capitalize"
      >
        <b-select
          :placeholder="$translate('placeholder_client')"
          v-model="shop.companyId"
          :disabled="this.id != undefined"
          @input="onCompanyChanged()"
        >
          <option v-for="company in availableCompanies" :value="company.id" :key="company.id">{{
            company.name
          }}</option>
        </b-select>
      </b-field>
      <b-field
        :type="{ 'is-danger': errors.has('name') }"
        :message="errors.first('name')"
        horizontal
        :label="$translate('name') | capitalize"
      >
        <b-input name="name" v-model="shop.name" v-validate="'required'"></b-input>
      </b-field>
      <!--<b-field :label="$translate('country') | capitalize" horizontal>
        <b-select :placeholder="$translate('placeholder_country')" v-model="shop.country">
          <option
            v-for="option in countries"
            :value="option['code']"
            :key="option['code']"
            >{{ $translate(option["code"]) }}</option
          >
        </b-select>
      </b-field>-->
      <b-field
        horizontal
        :label="$translate('mail') | capitalize"
        :type="{ 'is-danger': errors.has('email') }"
        :message="errors.first('email')"
      >
        <b-input name="email" v-validate="'email'" v-model="shop.email"></b-input>
      </b-field>
      <b-field
        horizontal
        :label="$translate('tel') | capitalize"
        :type="{ 'is-danger': errors.has('phone') }"
        :message="errors.first('phone')"
      >
        <b-input name="phone" v-model="shop.phone"></b-input>
      </b-field>
      <b-field horizontal :label="$translate('shops_active') | capitalize">
        <b-switch v-model="shop.isActive"></b-switch>
      </b-field>

      <p class="is-size-5">{{ $translate('address') | capitalize }}</p>
      <address-form :address.sync="shop.address"></address-form>
      <b-field horizontal :label="$translate('shipping_bool') | capitalize">
        <b-switch v-model="shop.useForShipping"></b-switch>
      </b-field>

      <!--<p class="control is-pulled-right">
        <button class="button is-primary" @click="send">
          {{ $translate("save") }}
        </button>
      </p>-->
    </div>

    <b-modal :active.sync="isSavingModal" has-modal-card trap-focus aria-role="dialog" aria-modal :can-cancel="false">
      <div class="modal-card" style="width: auto; min-width: 200px;">
        <section class="modal-card-body">
          <b-progress type="is-success" :value="progressvalue"></b-progress>
        </section>
      </div>
    </b-modal>

    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
  </section>
</template>

<script>
//import firebase from "firebase";
import addressForm from '@/components/AddressForm.vue'
import permissionMixin from '../../helpers/mixins/permissionMixin'
import keyWordGenerator from '@/helpers/mixins/keyWordGenerator.js'
import utilities from '../../helpers/mixins/utilities'

export default {
  $_veeValidate: {
    validator: 'new',
  },
  name: 'shopForm',
  components: {
    'address-form': addressForm,
  },
  mixins: [permissionMixin, keyWordGenerator, utilities],
  props: ['id'],
  data() {
    //var now = new Date();
    return {
      isLoading: false,
      isSavingModal: false,
      progressvalue: 0,
      availableCompanies: [],
      countries: [],
      shop: {
        //country: null,
        companyId: null,
        mercurio_id: '',
        name: '',
        email: '',
        phone: '',
        useForShipping: true,
        address: {
          city: '',
          country: '',
        },
        isActive: true,
      },
    }
  },
  async mounted() {
    if (!(this.userInfo.type == 'A' || (this.userInfo.type == 'I' && this.userInfo.level == 'S'))) {
      this.$router.push('/forbidden')
    }
    await this.loadCompanies()
    if (this.id) {
      await this.loadDataToEdit()
    }
  },
  methods: {
    async deleteItem() {
      await this.dialog('attention', 'delete_confirm_text', 'undo', 'delete', async () => {
        await this.$db
          .collection('shops')
          .doc(this.id)
          .delete()
        this.notification('success_delete', 'is-success')
        this.$router.push({ name: 'shops' })
      })
    },
    async send(exitbool) {
      const passed = await this.$validator.validateAll()
      if (!passed) {
        this.notification(this.$translate('failed_form', 'is-danger'))
        return
      }
      this.shop.searchArray = this.generateKeyWord([
        this.shop.name,
        this.shop.mercurio_id,
        this.shop.address.city,
        this.availableCompanies.find(e => e.id == this.shop.companyId).name,
      ])
      this.id == 0 || this.id == null ? await this.newRequest(exitbool) : await this.updateRequest(exitbool)
    },
    async newRequest(exitbool) {
      this.isLoading = true
      this.shop.registeredAt = new Date().getTime()
      try {
        const doc = await this.$db.collection('shops').add(this.shop)
        this.id = doc.id
        this.notification('success_form', 'is-success')
        this.isLoading = false
        if (exitbool) this.$router.push({ name: 'shops' })
      } catch {
        this.notification('error_form_server', 'is-danger')
        this.isLoading = false
      }
    },
    async updateRequest(exitbool) {
      var batch = this.$db.batch()
      var updateshop = this.$db.collection('shops').doc(this.id)

      if (!this.shop.orders || this.shop.orders.length < 499) {
        this.isLoading = true

        batch.update(updateshop, this.shop)
        //TODO:500 limite
        for (let orders in this.shop.orders) {
          let updateorder = this.$db.collection('orders').doc(this.shop.orders[orders])
          batch.update(updateorder, { shop: this.shop })
        }
        batch
          .commit()
          .then(() => {
            this.$buefy.notification.open({
              duration: 3000,
              message: this.$translate('success_form'),
              type: 'is-success',
            })
            this.isLoading = false

            if (exitbool) {
              this.$router.push({ name: 'shops' })
            }
          })
          .catch(() => {
            //console.log(err);
            this.isLoading = false

            this.$buefy.notification.open({
              duration: 3000,
              message: this.$translate('error_form_server'),
              type: 'is-danger',
            })
          })
      } else {
        this.isSavingModal = true
        let counter = 0

        for (let orders in this.shop.orders) {
          await this.$db
            .collection('orders')
            .doc(this.shop.orders[orders])
            .update({
              shop: this.shop,
            })
            .then(() => {
              counter++
              this.progressvalue = (100 * counter) / this.shop.orders.length - 1
            })
            .catch(() => {})
        }
        await this.$db
          .collection('shops')
          .doc(this.id)
          .update(this.shop)
        this.progressvalue = 100
        this.isSavingModal = false
        this.$buefy.notification.open({
          duration: 3000,
          message: this.$translate('success_form'),
          type: 'is-success',
        })
      }
    },

    async loadDataToEdit() {
      const doc = await this.$db
        .collection('shops')
        .doc(this.id)
        .get()
      this.shop = doc.data()
    },
    async loadCompanies() {
      const docs = await this.$db.collection('companies').get()
      docs.forEach(d => {
        const company = d.data()
        company.id = d.id
        this.availableCompanies.push(company)
      })
    },
    onCompanyChanged() {
      if (!this.shop.mercurio_id)
        this.shop.mercurio_id = this.availableCompanies.find(e => e.id === this.shop.companyId).mercurio_id
    },
  },
}
</script>
